import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetcher } from "@/shared/core-configs";
import { API } from "@/config";
import type { CreateProductAdjustment } from "../types/ProductAdjustment";
import {
  GET_PRODUCT_ADJUSTMENTS_FETCH_KEY,
  ProductAdjustment,
} from "@/shared/core-product-adjustments";

export const createProductAdjustment = async (
  productAdjustmentData: CreateProductAdjustment,
): Promise<ProductAdjustment> => {
  try {
    console.log("Datos enviados al servidor:", productAdjustmentData);

    const response = await fetcher.post(
      `${API.GESLUB}/product-adjustments`,
      productAdjustmentData,
    );

    console.log("Respuesta del servidor:", response);

    return response.data as ProductAdjustment;
  } catch (error) {
    console.error(
      "Error en la solicitud de creación de ajuste de producto",
      error,
    );
    throw error;
  }
};

export const useCreateProductAdjustment = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createProductAdjustment,
    onError: (error) => {
      console.error("Error al crear la  ajuste de producto:", error);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GET_PRODUCT_ADJUSTMENTS_FETCH_KEY],
      });
    },
  });
};
